import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-landtesti',
  templateUrl: './landtesti.component.html',
  styleUrls: ['./landtesti.component.css']
})
export class LandtestiComponent {

  // li: any;
  // list = []
  // constructor(private http: HttpClient) { }

  // ngOnInit(): void {
  //   // this.http.get('https://api3.ecell.in/eureka22/testimonials/')
  //   // .subscribe(Response => {
  //   //   if(Response){ }
  //   //   this.li=Response;
  //   //   this.list=this.li.testi;
  //   // });
  // }

  // position: number = 3;
  // absPosition: number;

  // prev(): void {
  //   if (this.position > 1) {
  //     this.position--;
  //   }
  //   else if(this.position == 1){
  //     this.position = 5;
  //   }
  // }

  // next(): void {
  //   if (this.position < 5) { // Modify this value based on the number of items
  //     this.position++;
  //   }
  //   else if(this.position == 5){
  //     this.position = 1;
  //   }
  // }
  readonly TESTIMONIALS = [
    {
      name: '',
      logo: '',
      quote: '',
    },
  ];

}
